export const emptyData = {
  model: {},
  baseSpec: {},
  pictures: {},
  offers: {},
  other: [],
  specifications: [],
  accessories: [],
  reviewsList: {},
  questions: {},
  linkedModels: [],
};

export const emptyModelData = {
  model: {},
  baseSpec: {
    show_description_in_modelcard: false,
    show_presets_anchor_in_modelcard: false,
    specifications: [],
  },
  offers: [],
  accessories: [],
  reviewsList: {},
  questions: {},
  navSections: [],
  popularOffer: null,
  active: '',
};
